import type { JsonSchema } from '../types/schema';
import type { StoredState } from '../types/model';
import { normalizeSchema } from './schemaUtils';

const STORAGE_KEY = 'visual-data-modeler-state';

export const loadStoredState = (storageKey: string = STORAGE_KEY): StoredState | null => {
  try {
    const raw = window.localStorage.getItem(storageKey);
    if (!raw) {
      return null;
    }
    const parsed = JSON.parse(raw) as StoredState;
    if (!parsed?.schema || typeof parsed.schema !== 'object') {
      return null;
    }
    const normalizedSchema = normalizeSchema(parsed.schema as JsonSchema);
    const normalizedVersions = (parsed.versions ?? []).map((snapshot) => ({
      ...snapshot,
      schema: normalizeSchema(snapshot.schema as JsonSchema),
    }));
    return {
      schema: normalizedSchema,
      versions: normalizedVersions,
      enforceIndexedInheritance: parsed.enforceIndexedInheritance ?? true,
    };
  } catch {
    return null;
  }
};

export const persistStoredState = (state: StoredState) => {
  try {
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch {
    // Ignore persistence errors (private mode, quota).
  }
};

export const persistStoredStateWithKey = (state: StoredState, storageKey: string = STORAGE_KEY) => {
  try {
    window.localStorage.setItem(storageKey, JSON.stringify(state));
  } catch {
    // Ignore persistence errors (private mode, quota).
  }
};
